export const toPhoneLink = value => value ? $('<a>').attr('href', `tel:${value}`).text(value) : null;

export default () => ({
  scope: { phone: "=evaPhoneLink" },
  link($scope, $element) {
    $element.html(toPhoneLink($scope.phone));
  }
})
